import { useFlags } from "launchdarkly-react-client-sdk";

export const useMfaEnabled = ({
  user,
}: {
  user?: {
    use_mfa?: boolean | null;
    client_account?: {
      auth0_metadata?: { use_mfa?: boolean } | unknown;
    } | null;
  };
}) => {
  const { mfaEnabled } = useFlags();

  const userMfaEnabled = user?.use_mfa ?? false;

  const clientAccountMfaEnabled =
    (
      user?.client_account?.auth0_metadata as {
        use_mfa?: boolean | null | undefined;
      }
    )?.use_mfa ?? false;

  return {
    //if flag is enabled, return the mfa status based on the client account and user mfa status
    //if flag is disabled, return null
    mfaEnabled: mfaEnabled ? clientAccountMfaEnabled || userMfaEnabled : null,
    userMfaEnabled,
    clientAccountMfaEnabled,
  };
};
